import LexiconLanguage from "./LexiconLanguage";

export interface LexiconStemProps {
    language: LexiconLanguage;
    text: string;
}

export default class LexiconStem {

    public constructor(private readonly props: LexiconStemProps) {
    }

    public getLanguage(): LexiconLanguage {
        return this.props.language;
    }

    public getText(): string {
        return this.props.text;
    }
}
